import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
      themes: {
        light: {
          primary: '#171717',
          secondary: '#f1ece7',
          accent: '#fb671a',
          error: '#b71c1c',
        },
      },
    },
  });


